import  React from "react";

class BaseClass extends React.Component{
  constructor(props){
    super(props);
    this.state = {};
    this.state.filtersState = {};
    this.state.dataList = {};
    this.state.renewMutex = {};
    this.updateStateWithStoreProps = this.updateStateWithStoreProps.bind(this);
  }

  updateStateWithStoreProps(nextProps = null){
    if(nextProps !== null && nextProps.store !== undefined && nextProps.store !== null){
      this.state.filtersState = nextProps.store.filtersState;
      this.state.dataList = nextProps.store.dataList;
      this.state.renewMutex = nextProps.store.renewMutex;
    }else if(this.props.store !== undefined && this.props.store !== null ){
  		this.state.filtersState = this.props.store.filtersState;
  		this.state.dataList = this.props.store.dataList;
  		this.state.renewMutex = this.props.store.renewMutex;
    }
	}

  shouldComponentUpdate(nextProps, nextState){
    return (JSON.stringify(nextProps.store) !== JSON.stringify(this.props.store)  || JSON.stringify(nextState) !== JSON.stringify(this.state))
  }

}

export default BaseClass;
